// Shared identity for device group/metric grid rows. Newly-created rows (added via the
// template compare popup, or freeform in the device drawer) don't have a real backend
// `id` yet - the backend assigns one on save - so `id` alone can't be used as a stable
// grid key/lookup before that round-trip. `_uiKey` is a client-only field set at row
// creation time to cover that gap; once a row has been saved and reloaded from the
// backend, `id` is always defined and takes over.
export function getRowKey(row: any): any {
  return row?._uiKey ?? row?.id;
}
